export default {
    setRequestError(state, payload){
      state.request_error = payload.message;
    },
    setCustomers(state, payload) {
      state.customers_of_search = payload;
    }
  };